export function isUnique(list: any[]): boolean {
  return new Set(list).size === list.length;
}

/**
 * 구성비 중첩률 계산 함수
 * SUM_N(MIN(arr1[i], arr2[i])) / SUM_N(MAX(arr1[i], arr2[i]))
 */
export function calcArraySimilarity(
  goalArr: number[],
  resultArr: number[],
): number {
  const length = Math.max(goalArr.length, resultArr.length);

  let minSum = 0,
    maxSum = 0;
  for (let i = 0; i < length; i++) {
    const [g, r] = [goalArr[i] ?? 0, resultArr[i] ?? 0];

    minSum += Math.min(g, r);
    maxSum += Math.max(g, r);
  }

  return minSum / maxSum;
}
